import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDrillDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M14.002 4.94a.75.75 0 0 1 .996 1.12l-4.433 3.942a.85.85 0 0 1-1.13 0L5.002 6.06a.75.75 0 1 1 .996-1.122L10 8.497l4.002-3.558Z" />
    <path d="M14.002 9.94a.75.75 0 0 1 .996 1.12l-4.433 3.941a.85.85 0 0 1-1.13 0l-4.433-3.94a.75.75 0 0 1 .996-1.122L10 13.496z" />
  </svg>
);
export default SvgDrillDown;
